import { useState, useEffect } from 'react';

/**
 * Custom hook for detecting user's motion preferences
 * @returns {object} - { prefersReducedMotion, isReducedMotion }
 */
const useReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    // Check if user prefers reduced motion
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    const handleChange = (event) => {
      setPrefersReducedMotion(event.matches);
    };

    // Set initial value
    setPrefersReducedMotion(mediaQuery.matches);

    // Listen for changes
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return { 
    prefersReducedMotion, 
    isReducedMotion: prefersReducedMotion 
  };
};

export default useReducedMotion;
